// ── Group cover art ─────────────────────────────────────────────────────────────
// Gives every group a representative "picture" based on its type — a kitchen theme for
// Cooking, a music theme for Music, etc. Works offline (gradient + emoji, always renders);
// an admin-set `imageUrl` (real photo) overrides it when present.
import { personaById } from './personas';

// category → { emoji, gradient }
const CATEGORY_ART = {
  'Cooking':      { emoji: '🍳', gradient: 'linear-gradient(135deg,#f97316,#ef4444)' },
  'Art & Design': { emoji: '🎨', gradient: 'linear-gradient(135deg,#ec4899,#8b5cf6)' },
  'Music':        { emoji: '🎵', gradient: 'linear-gradient(135deg,#8b5cf6,#6366f1)' },
  'Gaming':       { emoji: '🎮', gradient: 'linear-gradient(135deg,#6366f1,#0ea5e9)' },
  'Science':      { emoji: '🔬', gradient: 'linear-gradient(135deg,#14b8a6,#0ea5e9)' },
  'Writing':      { emoji: '✍️', gradient: 'linear-gradient(135deg,#f59e0b,#ea580c)' },
  'Business':     { emoji: '💼', gradient: 'linear-gradient(135deg,#475569,#1e293b)' },
  'Sports':       { emoji: '🏅', gradient: 'linear-gradient(135deg,#22c55e,#15803d)' },
  'Language':     { emoji: '🗣️', gradient: 'linear-gradient(135deg,#06b6d4,#3b82f6)' },
  'Programming':  { emoji: '💻', gradient: 'linear-gradient(135deg,#1a73e8,#1557b0)' },
  'Gardening':    { emoji: '🌱', gradient: 'linear-gradient(135deg,#84cc16,#15803d)' },
  'Reading':      { emoji: '📚', gradient: 'linear-gradient(135deg,#d97706,#92400e)' },
  'Dance':        { emoji: '💃', gradient: 'linear-gradient(135deg,#e11d48,#be185d)' },
  'Crafts':       { emoji: '🧵', gradient: 'linear-gradient(135deg,#f43f5e,#e11d48)' },
  'Photography':  { emoji: '📷', gradient: 'linear-gradient(135deg,#64748b,#334155)' },
  'Outdoor Activity': { emoji: '🏕️', gradient: 'linear-gradient(135deg,#16a34a,#065f46)' },
};

const BROAD_ART = {
  food:    { emoji: '🍲', gradient: 'linear-gradient(135deg,#f97316,#ef4444)' },
  tutor:   { emoji: '📚', gradient: 'linear-gradient(135deg,#1a73e8,#6366f1)' },
  sports:  { emoji: '🏅', gradient: 'linear-gradient(135deg,#22c55e,#15803d)' },
  classes: { emoji: '🎨', gradient: 'linear-gradient(135deg,#ec4899,#8b5cf6)' },
  expert:  { emoji: '🏆', gradient: 'linear-gradient(135deg,#f59e0b,#ea580c)' },
  shop:    { emoji: '🛍️', gradient: 'linear-gradient(135deg,#8b5cf6,#6366f1)' },
  events:  { emoji: '🎪', gradient: 'linear-gradient(135deg,#e11d48,#be185d)' },
  bhajan:  { emoji: '🕉️', gradient: 'linear-gradient(135deg,#f59e0b,#d97706)' },
  media:   { emoji: '🎬', gradient: 'linear-gradient(135deg,#64748b,#334155)' },
};

const DEFAULT_ART = { emoji: '🌟', gradient: 'linear-gradient(135deg,#1a73e8,#8b5cf6)' };

// Resolve the best cover for a group: persona → broad category → category → default.
export function groupCover(group) {
  if (!group) return DEFAULT_ART;
  const persona = group.persona && personaById(group.persona);
  const base = BROAD_ART[group.broadCategory] || CATEGORY_ART[group.category] || DEFAULT_ART;
  // If a persona is set, use its emoji over the derived gradient (finer-grained picture).
  const emoji = persona ? persona.emoji : base.emoji;
  return { emoji, gradient: base.gradient, imageUrl: group.imageUrl || '' };
}
